import React, { useContext, useEffect, useRef, useState } from 'react';
import './styles.less';
import { CreateSearchAlert } from 'shared-components/Components/SearchAlert/CreateSearchAlert/web';
import { ActiveFiltersTags } from '../ActiveFiltersTags/web';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import { formatMoney, normalizeTextToLowerCase } from '@Utils/Functions';
import ToggleInput from 'shared-components/Components/ToggleInput/web';
import { DownArrow } from 'shared-components/Components/CustomIcons/DownArrow/web';
import { Location as NewLocation } from 'shared-components/Components/Filters/Location/newLocation';
import { useSearchResultsFilters } from '../Filters/SearchResultsFilters.hook';
import { Amenities } from './Amenities/web';
import { useActiveFiltersTags } from '../ActiveFiltersTags/ActiveFiltersTags.hook';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import InputFilterBox from './InputFilterBox/web';
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import {
  bathrooms,
  buildingFloor,
  currencyType,
  dispositionFilter,
  operation_type_id,
  propertyState,
  property_type_id,
  publicationDate,
  seaDistance,
  surfaceRange,
  bedrooms,
  seasonsFilters
} from './options';
import { DataOptionsTypes } from './types';
import { Keywords } from './Keywords/web';
import { CheckIcon } from 'shared-components/Components/CustomIcons/CheckIcon/web';

const TopBarFilters = () => {
  const { filters, changeFilters: updateFilters } = useFilters()
  const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters()
  const { country_code } = useContext(ConfigStateContext);
  const { filtersTagsToShow } = useActiveFiltersTags();
  const [filterValues, setFilterValues] = useState({
    minPrice: filters?.minPrice || null,
    maxPrice: filters?.maxPrice || null,
    currencyValue: filters?.currencyID || 1,
    m2Min: filters?.m2Min || null,
    m2Max: filters?.m2Max || null,
    m2Type: filters?.m2Type || null,
    checkedValues: [],
  });

  const [showSeasons, setShowSeasons] = useState<boolean>(filters?.season ? true : false)
  const [guests, setGuests] = useState<number>(filters?.guests ? filters?.guests : 0)
  const [rangeDate, setRangeDate] = useState<any>([filters?.dateFrom && filters?.dateFrom, filters?.dateTo && filters?.dateTo]);
  const submitButtonPrice = useRef(null)
  const [calendarIsOpen, setCalendarIsOpen] = useState<boolean>()
  const [currencySymbol, setCurrencySymbol] = useState<string>('U$S')
  const [monedaLocal, setMonedaLocal] = useState<number>(1)
  
  const watchCheckedInFilter = (filterTypeObj, filterType) => {
    return filterTypeObj ? filterTypeObj.map((val) => ({ ...val, value: val.value, text: val.text, checked: filterType?.includes(val.value) })) : []
  }
  const setLabelWithOptionsSelected = (filterTypeObj, filterType, defaultValue: string) => {
    return filterType ? filterTypeObj.filter((e) => filterType.includes(e.value)).map(v => v.text).join(', ') : [defaultValue]
  }
  const propertyTypeId: DataOptionsTypes[] = watchCheckedInFilter(property_type_id, filters?.property_type_id).filter(e => e.countries.includes(country_code ? country_code.toUpperCase() : "".toUpperCase()))
  const bedroomsList: DataOptionsTypes[] = watchCheckedInFilter(bedrooms, filters?.bedrooms)
  const bathroomsList: DataOptionsTypes[] = watchCheckedInFilter(bathrooms, filters?.bathrooms)
  const properTyStateList: DataOptionsTypes[] = watchCheckedInFilter(propertyState, filters?.constStatesID)
  const buildingFloorList: DataOptionsTypes[] = watchCheckedInFilter(buildingFloor, filters?.floors)
  const dispositionFilterList: DataOptionsTypes[] = watchCheckedInFilter(dispositionFilter, filters?.dispositionID)
  const currencyTypeList = currencyType.filter(e => e.countries.includes(country_code ? country_code.toUpperCase() : ""))
  const operationTypeIdList: DataOptionsTypes[] = operation_type_id.filter((p) => p.countries.includes(country_code ? country_code.toUpperCase() : ""))

  useEffect(()=>{
	const obj = currencyTypeList.find(m=>m.countries.includes(country_code))
	if(obj)setMonedaLocal(obj.value)
	else setMonedaLocal(1)
  },[currencyTypeList])

  useEffect(()=>{
	if(filters.operation_type_id===1){
		setFilterValues((prev)=>({...prev,currencyValue:1}))
		changeFilters({currencyID:{text:undefined,value:1}})
	}
	else{
		setFilterValues((prev)=>({...prev,currencyValue:monedaLocal}))
		changeFilters({currencyID:{text:undefined,value:monedaLocal}})
	}
  },[monedaLocal])

  useEffect(()=>{
	if (filterValues.currencyValue) {
      const obj = currencyTypeList?.find(v => v.value == filterValues.currencyValue)
      const val = obj?.text.split(' ')[0]
      setCurrencySymbol(val)
    }
	else {
		setCurrencySymbol('U$S')
	}

  },[filterValues.currencyValue, currencyTypeList])

  const submitPrice = () => {	
    const res = {
      minPrice: filterValues.minPrice && { text: `Desde ${currencySymbol} ${formatMoney(filterValues.minPrice)}`, value: filterValues.minPrice },
      maxPrice: filterValues.maxPrice && { text: `Hasta ${currencySymbol} ${formatMoney(filterValues.maxPrice)}`, value: filterValues.maxPrice },
      currencyID: { text: undefined, value: filterValues.currencyValue }
    }
    changeFilters(res)
  }

  const handleMinPrice = (e) => {
    const inputNum = e.target.value.replace(/\D/g, '')
    const formattedNum = formatMoney(inputNum)

    setFilterValues((prevState) => ({
      ...prevState,
      minPrice: Number(inputNum),
    }));

    e.target.value = formattedNum
  }

  const handleMaxPrice = (e) => {
    const inputNum = e.target.value.replace(/\D/g, '')
    const formattedNum = formatMoney(inputNum)

    setFilterValues((prevState) => ({
      ...prevState,
      maxPrice: Number(inputNum),
    }));

    e.target.value = formattedNum
  }

  const submitRangeSurface = () => {
    const res = {
      m2Type: filterValues.m2Type && { text: undefined, value: filterValues.m2Type },
      m2Min: filterValues.m2Min && { text: `Desde ${formatMoney(filterValues.m2Min)}m²`, value: filterValues.m2Min },
      m2Max: filterValues.m2Max && { text: `Hasta ${formatMoney(filterValues.m2Max)}m²`, value: filterValues.m2Max }
    }    
    changeFilters(res)
  }

  const selectRangeType = (val) => {
    setFilterValues((prevState) => ({
      ...prevState,
      m2Type: val,
    }));    
    changeFilters({ m2Type: { text: undefined, value: val } })
  }

  const handleMinM2 = (e) => {
    const inputNum = e.target && e.target.value ? e.target.value.replace(/\D/g, '') : ''
    const formattedNum = formatMoney(inputNum)
    setFilterValues((prevState) => ({
      ...prevState,
      m2Min: Number(inputNum),
    }));
    e.target.value = formattedNum
  }

  const handleMaxM2 = (e) => {
    const inputNum = e.target && e.target.value ? e.target.value.replace(/\D/g, '') : ''
    const formattedNum = formatMoney(inputNum)
    setFilterValues((prevState) => ({
      ...prevState,
      m2Max: Number(inputNum),
    }));
    e.target.value = formattedNum
  }

  const handleFilterChange = (
    value: number,
    checked: boolean,
    list: DataOptionsTypes[],
    filterName: string
  ) => {
    if (list.length) {
      let newOptions = list?.map((item) =>
        item.value == value ? { ...item, checked: checked } : item
      );      
      let newFilters = newOptions
        .filter((v) => v.checked)
        .map((e) => ({ value: e.value, text: e.text }));
      changeFilters({ [filterName]: newFilters });
    }
  };

  const handlePropertyTypeId = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target

    if (checked && !filterValues.checkedValues.includes(value)) {
      setFilterValues((prevState) => ({
        ...prevState,
        checkedValues: [...prevState.checkedValues, value],
      }));
    } else {
      setFilterValues((prevState) => ({
        ...prevState,
        checkedValues: prevState.checkedValues.filter((val) => val !== value),
      }));
    }

    handleFilterChange(Number(value), checked, propertyTypeId, 'property_type_id');
  }
  const handleBedrooms = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target
    handleFilterChange(Number(value), checked, bedroomsList, 'bedrooms');
  }
  const handleBathrooms = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target
    handleFilterChange(Number(value), checked, bathroomsList, 'bathrooms');
  }

  const handlePropertyState = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target
    handleFilterChange(Number(value), checked, properTyStateList, 'constStatesID')
  }

  const handleFloor = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target
    handleFilterChange(Number(value), checked, buildingFloorList, 'floors')
  }

  const handleDisposition = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e?.target
    handleFilterChange(Number(value), checked, dispositionFilterList, 'dispositionID')
  }

  const propertyTypeDescription: string = setLabelWithOptionsSelected(property_type_id, filters?.property_type_id, 'Tipo de Inmueble')
  const bedroomsDescription: string = setLabelWithOptionsSelected(bedrooms, filters?.bedrooms, 'Dormitorios')

  const handleCleanFilters = () => {
    filtersTagsToShow.map((filter) => {
      if (filter.deleteable) {
        if (filter.key === "property_type_id" ||
          filter.key === "bedrooms" ||
          filter.key === "bathrooms" ||
          filter.key === "constStatesID" ||
          filter.key === "neighborhood_id" ||
          filter.key === "facilitiesGroup"
        ){          
          changeFilters({ [filter.key]: [] })
        }
        else {          
          changeFilters(filter.onChangeObject)
        }
      }
    })
    setRangeDate(null)
  }
  useEffect(() => {
    if (rangeDate && rangeDate[0]) {
      const startRange = rangeDate[0]
      const endRange = rangeDate[1]                  

      if (startRange || endRange) {        
        changeFilters({ dateFrom: startRange && startRange !== '' ? { text: startRange, value: startRange } : null, dateTo: endRange && endRange !== '' ? { text: endRange, value: endRange } : null, season: null })
      }
      else if (!startRange && !endRange) {        
        changeFilters({ dateFrom: null, dateTo: null, season: null })
      }
    }
  }, [rangeDate])

  useEffect(() => {
    if (!filters?.dateFrom && filters?.dateTo) {
      setRangeDate(['', filters?.dateTo])
    }
    if (!filters?.dateTo && filters?.dateFrom) {
      setRangeDate([filters?.dateFrom, ''])
    }
    if (!filters?.dateTo && !filters?.dateFrom) setRangeDate(null)
  }, [filters?.dateFrom, filters?.dateTo])

  const handleGuests = () => {
    if (guests !== 0) {      
      changeFilters({ guests: { value: guests, text: `${guests} o más Huéspedes` } })
    }
    else {      
      changeFilters({ guests: undefined })
    }
  }

  const handleOperationID = (value:DataOptionsTypes)=>{	
	changeFilters({ operation_type_id: value, minPrice:undefined, maxPrice:undefined })
	let moneda = 1
	if(value.value===1) moneda = 1
	else {		
		moneda = Number(monedaLocal)
	}
	setFilterValues((prev)=>({...prev,currencyValue:moneda,minPrice:'',maxPrice:''}))
  }

  const renderPrice = ()=>{
    if(country_code==='UY' && filters.operation_type_id===1){
      return (
        <div className="priceRangeFilter__currency__option">
          <input
            type="radio"
            className="radioCustomInput"
            name="currencyID"
            id="U$S - Dólares Americanos"
            value="1"
            checked={true}
          />
          <label htmlFor="U$S - Dólares Americanos">U$S - Dólares Americanos</label>
        </div>
		)
    }
    else if(country_code!=='UY'){
      return currencyTypeList.map((val, i) => {
        return <div
		key={val.text + "-" + i}
		className="priceRangeFilter__currency__option">
		<input
		  type="radio"
		  className="radioCustomInput"
		  name={"currencyID"}
		  id={val.text}
		  checked={filterValues.currencyValue === val.value}
		  value={val.value}
		  onClick={() =>
			setFilterValues(prevState => ({
			  ...prevState,
			  currencyValue: val.value,
			}))
		  }
		/>
		<label htmlFor={val.text}>{val.text}</label>
	  </div>
      })
    }
    else{
     return currencyTypeList.map((val, i) => {
        if (val.value === filters.currencyID) {
          return (
            <div
              key={val.text + "-" + i}
              className="priceRangeFilter__currency__option">
              <input
                type="radio"
                className="radioCustomInput"
                name={"currencyID"}
                id={val.text}
                checked={filterValues.currencyValue === val.value}
                value={val.value}
                onClick={() =>
                  setFilterValues(prevState => ({
                    ...prevState,
                    currencyValue: val.value,
                  }))
                }
              />
              <label htmlFor={val.text}>{val.text}</label>
            </div>
          );
        }
        else{
          return (
            <div
              key={val.text + "-" + i}
              className="priceRangeFilter__currency__option">
              <input
                type="radio"
                className="radioCustomInput"
                name={"currencyID"}
                id={val.text}
				checked={filterValues.currencyValue === val.value}
                value={val.value}
                onClick={() =>
                  setFilterValues(prevState => ({
                    ...prevState,
                    currencyValue: val.value,
                  }))
                }
              />
              <label htmlFor={val.text}>{val.text}</label>
            </div>
          );
        }
      })
    }
  }

  return (
		<div className="topBarFilters">
			<div className="topBarFilters__activeFilters">
				<ActiveFiltersTags />

				{filtersTagsToShow.length !== 1 && (
					<button onClick={handleCleanFilters} className="clean-filters">
						Limpiar filtros
					</button>
				)}
			</div>

			<div className="topBarFilters__container">
				{/* Filtro ubicación */}
				<div className="topBarFilters__searchKeyword">
					<NewLocation
						changeFilters={changeFilters}
						currentEstate={filters?.estate_id ? filters?.estate_id : null}
						currentNeighbourhood={
							filters?.neighborhood_id ? filters?.neighborhood_id : null
						}
					/>
				</div>

				{/* Filtro de Tipo de Operación */}
				{operationTypeIdList && operationTypeIdList.length ? (
					<InputFilterBox
						label={
							filters && filters?.operation_type_id
								? operation_type_id.find(e => e.value == filters?.operation_type_id)
										.text
								: "Operación"
						}>
						<div className="optionList">
							{operationTypeIdList.map((val, i) => {
								return (
									<div key={val.text + "-" + i} className="optionList__option">
										<input
											type="radio"
											className="radioCustomInput"
											onChange={()=>handleOperationID(val)}
											name={"operation_type_id"}
											id={val.text}
											value={val.value}
											defaultChecked={val.value == filters?.operation_type_id}
										/>
										<label htmlFor={val.text}>{val.text}</label>
									</div>
								);
							})}
						</div>
					</InputFilterBox>
				) : (
					<></>
				)}

				{/* Filtro de Búsqueda por temporadas o fechas en Casas en el Este */}
				{country_code == "ce3" ||
				(filters?.operation_type_id && filters?.operation_type_id === 4) ? (
					<InputFilterBox
						label="Fechas"
						customWidth={360}
						customHeight={calendarIsOpen ? 515 : "unset"}>
						<div className="dateFilter">
							<div className="dateFilter__selectors">
								<button
									className="dateFilter__selector"
									disabled={!showSeasons}
									onClick={() => {
										setShowSeasons(false);
									}}>
									Buscar por Calendario
								</button>
								<button
									className="dateFilter__selector"
									disabled={showSeasons}
									onClick={() => {
										setShowSeasons(true);
									}}>
									Buscar por Temporada
								</button>
							</div>
							{showSeasons ? (
								<>
									<div className="otherFilters__container" id="publicationDate">
										<input
											className="otherFilters__dropDownIsActive"
											type="checkbox"
											id="selectSeason"
										/>
										<label
											className="otherFilters__dropDownSelector"
											htmlFor="selectSeason">
											Temporada
											<DownArrow />
										</label>
										<div className="otherFilters__dropdown">
											<div className="otherFilters__container__option more-filters">
												<input
													type="radio"
													className="radioCustomInput"
													name="season"
													id="indiferente"
													onChange={() =>
														changeFilters({
															season: null,
															dateFrom: null,
															dateTo: null,
														})
													}
													value="-1"
													defaultChecked
												/>
												<label htmlFor="indiferente">Indiferente</label>
											</div>
											{seasonsFilters.map((val, i) => {
												const idValue = normalizeTextToLowerCase(val.text);
												return (
													<div
														key={"season-filter - " + i}
														className="otherFilters__container__option more-filters">
														<input
															type="radio"
															className="radioCustomInput"
															name="season"
															id={idValue}
															onChange={() =>
																changeFilters({
																	season: {
																		text: val.text,
																		value: val.value,
																	},
																	dateFrom: null,
																	dateTo: null,
																})
															}
															value={val.value}
															defaultChecked={
																filters?.season &&
																filters?.season == val.value
															}
														/>
														<label htmlFor={idValue}>{val.text}</label>
													</div>
												);
											})}
										</div>
									</div>
								</>
							) : (
								<>
									<div className="dateFilter__labels">
										<span>Llegada</span>
										<div></div>
										<span>Salida</span>
									</div>
									<div className="dateFilter__calendar">
										<DateRangePicker
											format="dd/MM/yyyy"
											onChange={e => {
												if (e) {
													const values = e
														.toLocaleString("en", {
															year: "numeric",
															month: "2-digit",
															day: "2-digit",
														})
														.split(",");

													const dates = values.map(v => {
														if (v.split("/").length > 1) {
															const [month, day, year] = v.split("/");
															return `${year}/${month}/${day}`;
														} else "";
													});
													setRangeDate(dates);
												} else {
													setRangeDate(null);
												}
											}}
											value={rangeDate}
											calendarClassName=".filterCalendar"
											className=".filterCalendarPicker"
											minDate={new Date()}
											calendarIcon={null}
											clearIcon={null}
											onCalendarOpen={() => setCalendarIsOpen(true)}
											onCalendarClose={() => setCalendarIsOpen(false)}
										/>
									</div>
								</>
							)}
						</div>
					</InputFilterBox>
				) : (
					<></>
				)}

				{/* Filtro de Tipo de Propiedad */}
				<InputFilterBox label={propertyTypeDescription}>
					<div className="optionList">
						{propertyTypeId &&
							propertyTypeId.map((val, i) => {
								return (
									<div key={val.text + "-" + i} className="optionList__option">
										<input
											type="checkbox"
											className="checkBoxCustomInput"
											onChange={handlePropertyTypeId}
											name={"propertyTypeId"}
											id={val.text}
											value={val.value}
											checked={val.checked ? true : false}
										/>
										<label htmlFor={val.text}>{val.text}</label>
									</div>
								);
							})}
					</div>
				</InputFilterBox>

				{/* Filtro de Cantidad de Dormitorios */}
				<InputFilterBox label={bedroomsDescription}>
					<div className="optionList">
						{bedroomsList &&
							bedroomsList.map((val, i) => {
								return (
									<div key={val.text + "-" + i} className="optionList__option">
										<input
											type="checkbox"
											className="checkBoxCustomInput"
											onChange={handleBedrooms}
											name={"bedroomsList"}
											id={val.text}
											value={val.value}
											checked={
												filters?.bedrooms &&
												filters?.bedrooms.includes(val.value)
											}
										/>
										<label htmlFor={val.text}>{val.text}</label>
									</div>
								);
							})}
					</div>
				</InputFilterBox>

				{/* Filtro de Rango de Precios */}
				<InputFilterBox label="Precio" customWidth={280} buttonRef={submitButtonPrice}>
					<div className="priceRangeFilter">
						<div className="priceRangeFilter__currency">
							{
								renderPrice()
							}
						</div>
						<div className="priceRangeFilter__range">
							<input
								type="text"
								className="priceRangeFilter__range__input boxCustomInput"
								placeholder={`Min ${currencySymbol}`}
								onChange={handleMinPrice}
								value={filterValues.minPrice?formatMoney(filterValues.minPrice) : ''}
							/>
							-
							<input
								type="text"
								className="priceRangeFilter__range__input boxCustomInput"
								placeholder={`Max ${currencySymbol}`}
								onChange={handleMaxPrice}
								value={filterValues.maxPrice?formatMoney(filterValues.maxPrice):''}
							/>
						</div>
						<button
							ref={submitButtonPrice}
							className="priceRangeFilter__submitButton mainSubmitButton"
							onClick={submitPrice}>
							Aplicar rango
						</button>
					</div>
				</InputFilterBox>

				{/* Otros filtros */}
				<InputFilterBox label="Más filtros" customWidth={400} positionRight>
					<div className="otherFilters">
						{/* Filtro palabra clave */}
						<Keywords collapsable filterChanged={changeFilters} />

						{/* Filtro de Huéspedes*/}
						{country_code == "ce3" || (filters && filters?.operation_type_id == 4) ? (
							<div className="otherFilters__guests">
								<p>Huéspedes</p>
								<div className="otherFilters__count">
									<div>
										<button
											className="otherFilters__count__operation"
											disabled={guests === 0 ? true : false}
											onClick={() => setGuests(guests - 1)}>
											-
										</button>
										<input
											type="number"
											name="guests"
											id="guests"
											value={guests}
											onChange={e => setGuests(Number(e.target.value))}
										/>
										<button
											className="otherFilters__count__operation"
											onClick={() => setGuests(guests + 1)}>
											+
										</button>
									</div>
									<button
										className="otherFilters__count__submit"
										onClick={handleGuests}>
										<CheckIcon type="default" />
									</button>
								</div>
							</div>
						) : (
							<></>
						)}
						{/* Filtros de Baños */}
						<div className="otherFilters__container" id="bathrooms">
							<p>Baños</p>
							{bathroomsList &&
								bathroomsList.map((val, i) => {
									return (
										<div
											key={"bathrooms - " + i}
											className="otherFilters__container__option">
											<input
												type="checkbox"
												className="checkBoxCustomInput"
												name="bathrooms"
												onChange={handleBathrooms}
												id={val.text}
												checked={val.checked ? true : false}
												value={val.value}
											/>
											<label htmlFor={val.text}>{val.text}</label>
										</div>
									);
								})}
						</div>

						{/* Rango de Metraje */}
						<div className="otherFilters__container" id="rangeMeters">
							<p>
								Rango de Metraje (m<sup>2</sup>)
							</p>
							{surfaceRange &&
								surfaceRange.map((val, i) => {
									return (
										<div
											key={"rangeMeters - " + i}
											className="otherFilters__container__option">
											<input
												type="radio"
												className="radioCustomInput"
												name="rangeMeters"
												id={val.text}
												onClick={() => selectRangeType(val.value)}
												defaultChecked={
													filters?.m2Type == val.value
														? true
														: i === 0
														? true
														: false
												}
											/>
											<label htmlFor={val.text}>{val.text}</label>
										</div>
									);
								})}
							<div className="otherFilters__container__range">
								<input
									type="text"
									className="boxCustomInput"
									placeholder="Min"
									defaultValue={
										filterValues.m2Min && formatMoney(filterValues.m2Min)
									}
									onChange={handleMinM2}
									onBlur={submitRangeSurface}
								/>
								-
								<input
									type="text"
									className="boxCustomInput"
									onChange={handleMaxM2}
									placeholder="Max"
									defaultValue={
										filterValues.m2Max && formatMoney(filterValues.m2Max)
									}
									onBlur={submitRangeSurface}
								/>
							</div>
						</div>
						{/* Grupo de Opciones Toggle */}
						<div className="otherFilters__container" id="toggleFilters">
							{country_code !== "ce3" && (
								<ToggleInput
									id="tour-virtual"
									label="Tour Virtual"
									name="virtualTour"
									onChange={e =>
										changeFilters({
											tour3d: e.target.checked
												? { text: "Tour Virtual 3D", value: true }
												: null,
										})
									}
									defaultChecked={filters?.tour3d === true}
								/>
							)}
							<ToggleInput
								id="garage-filter"
								label="Garage"
								name="garage"
								onChange={e =>
									changeFilters({
										garage: e.target.checked
											? { text: "con Garage", value: 1 }
											: null,
									})
								}
								defaultChecked={filters?.garage == 1}
							/>
							{country_code !== "ce3" && (
								<ToggleInput
									id="socialhousing"
									label="Vivienda social"
									name="viviendaSocial"
									onChange={e =>
										changeFilters({
											socialHousing: e.target.checked
												? { text: "Vivienda Social", value: true }
												: null,
										})
									}
									defaultChecked={filters?.socialHousing}
								/>
							)}
							<ToggleInput
								id="privateowner-filter"
								label="Publicado por el dueño"
								name="publicateowner-filter"
								onChange={e =>
									changeFilters({
										privateOwner: e.target.checked
											? { text: "Dueño", value: true }
											: null,
									})
								}
								defaultChecked={filters?.privateOwner}
							/>
							{country_code !== "ce3" && (
								<ToggleInput
									id="condominium-filter"
									label={country_code === "UY" ? "Barrio Privado" : "Condominio"}
									name="condominium-filter"
									onChange={e =>
										changeFilters({
											condominium: e.target.checked
												? { text: "Condominios", value: true }
												: null,
										})
									}
									defaultChecked={filters?.condominium}
								/>
							)}
						</div>

						{/* Amenities */}
						<Amenities />

						{/* Estado de la Propiedad*/}
						{country_code !== "ce3" ? (
							<div className="otherFilters__container" id="property-state-filter">
								<p>Estado</p>
								{properTyStateList.map((val, i) => {
									const idValue = normalizeTextToLowerCase(val.text);
									return (
										<div
											key={"property-state-filter - " + i}
											className="otherFilters__container__option">
											<input
												type="checkbox"
												className="checkBoxCustomInput"
												name="property-state-filter"
												onChange={handlePropertyState}
												checked={
													filters?.constStatesID &&
													filters?.constStatesID.includes(val.value)
												}
												id={idValue}
												value={val.value}
											/>
											<label htmlFor={idValue}>{val.text}</label>
										</div>
									);
								})}
							</div>
						) : (
							<></>
						)}

						{/* Fecha de Publicación */}
						<div className="otherFilters__container" id="publicationDate">
							<input
								className="otherFilters__dropDownIsActive"
								type="checkbox"
								id="publicationDateDropDown"
							/>
							<label
								className="otherFilters__dropDownSelector"
								htmlFor="publicationDateDropDown">
								Fecha de Publicación
								<DownArrow />
							</label>
							<div className="otherFilters__dropdown">
								<div className="otherFilters__container__option more-filters">
									<input
										type="radio"
										className="radioCustomInput"
										name="publicationDate-filter"
										id="indiferente"
										onChange={() => changeFilters({ publicationDate: null })}
										value="-1"
										defaultChecked
									/>
									<label htmlFor="indiferente">Indiferente</label>
								</div>
								{publicationDate.map((val, i) => {
									const idValue = normalizeTextToLowerCase(val.text);
									return (
										<div
											key={"publicationDate-filter - " + i}
											className="otherFilters__container__option more-filters">
											<input
												type="radio"
												className="radioCustomInput"
												name="publicationDate-filter"
												id={idValue}
												onChange={() =>
													changeFilters({
														publicationDate: {
															text: val.text,
															value: val.value,
														},
													})
												}
												value={val.value}
												defaultChecked={
													filters?.publicationDate &&
													filters?.publicationDate == val.value
												}
											/>
											<label htmlFor={idValue}>{val.text}</label>
										</div>
									);
								})}
							</div>
						</div>

						{/* Distancia al Mar */}
						{country_code !== "PY" && country_code !== "BO" && (
							<div className="otherFilters__container" id="seaDistance">
								<input
									className="otherFilters__dropDownIsActive"
									type="checkbox"
									id="seaDistanceFilterDropdown"
								/>
								<label
									className="otherFilters__dropDownSelector"
									htmlFor="seaDistanceFilterDropdown">
									Distancia al Mar
									<DownArrow />
								</label>
								<div className="otherFilters__dropdown">
									<div className="otherFilters__container__option more-filters">
										<input
											type="radio"
											className="radioCustomInput"
											name="sea-distance-filter"
											id="cualquiera"
											onChange={() => changeFilters({ seaDistanceID: null })}
											value="-1"
											defaultChecked
										/>
										<label>Cualquier Distancia</label>
									</div>
									{seaDistance.map((val, i) => {
										return (
											<div
												key={"sea-distance-filter - " + i}
												className="otherFilters__container__option more-filters">
												<input
													type="radio"
													className="radioCustomInput"
													name="sea-distance-filter"
													id={val.text}
													onChange={() =>
														changeFilters({
															seaDistanceID: {
																value: val.value,
																text:
																	val.value === 1
																		? val.text
																		: `${val.text} del mar`,
															},
														})
													}
													value={val.value}
													defaultChecked={
														filters?.seaDistanceID &&
														filters?.seaDistanceID === val.value
													}
												/>
												<label htmlFor={val.text}>{val.text}</label>
											</div>
										);
									})}
								</div>
							</div>
						)}
						{//validación para que aparezca el filtro de pisos en el caso de que el tipo de propiedad sea departamento o apartamento
						country_code !== "ce3" &&
							filters?.property_type_id &&
							filters?.property_type_id.includes(2) && (
								<>
									{/* Cantidad de Pisos */}
									<div className="otherFilters__container" id="buildingFloor">
										<input
											className="otherFilters__dropDownIsActive"
											type="checkbox"
											id="floorsFiltersDropdown"
										/>
										<label
											className="otherFilters__dropDownSelector"
											htmlFor="floorsFiltersDropdown">
											Pisos
											<DownArrow />
										</label>
										<div className="otherFilters__dropdown">
											{buildingFloorList.map((val, i) => {
												const idValue = normalizeTextToLowerCase(val.text);
												return (
													<div
														key={"building-floor - " + i}
														className="otherFilters__container__option more-filters">
														<input
															type="checkbox"
															className="checkBoxCustomInput"
															name="building-floor"
															onChange={handleFloor}
															checked={val.checked ? true : false}
															id={idValue}
															value={val.value}
														/>
														<label htmlFor={idValue}>{val.text}</label>
													</div>
												);
											})}
										</div>
									</div>

									<div className="otherFilters__container" id="disposition">
										<input
											className="otherFilters__dropDownIsActive"
											type="checkbox"
											id="dispositionFiltersDropdown"
										/>
										<label
											className="otherFilters__dropDownSelector"
											htmlFor="dispositionFiltersDropdown">
											Disposición
											<DownArrow />
										</label>
										<div className="otherFilters__dropdown">
											{dispositionFilterList.map((val, i) => {
												const idValue = normalizeTextToLowerCase(val.text);
												return (
													<div
														key={"disposition-filter - " + i}
														className="otherFilters__container__option more-filters">
														<input
															type="checkbox"
															className="checkBoxCustomInput"
															name="dispositionFilter"
															onChange={handleDisposition}
															checked={val.checked ? true : false}
															id={idValue}
															value={val.value}
														/>
														<label htmlFor={idValue}>{val.text}</label>
													</div>
												);
											})}
										</div>
									</div>
								</>
							)}
					</div>
				</InputFilterBox>

				<div className="topBarFilters__createAlert">
					<CreateSearchAlert />
				</div>
			</div>
		</div>
  );
}




export default TopBarFilters